import { alpha, css, styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import type { StickyPosition } from '@openx/types/tableHelpers.ts';
import { STICKY_POSITION } from '@openx/types/tableHelpers.ts';
import type { JSX, ReactNode } from 'react';

export const ICON_CELL_CLASS = 'iconCell';

const StyledTableCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'sticky' && prop !== 'stickyRightOffset' && prop !== 'isLeadingStickyRight',
})<{ sticky?: StickyPosition; stickyRightOffset?: number; isLeadingStickyRight?: boolean }>`
  text-align: center;

  ${({ sticky, stickyRightOffset, isLeadingStickyRight, theme }) =>
    sticky === STICKY_POSITION.RIGHT &&
    css`
      position: sticky;
      right: ${stickyRightOffset || 0}px;
      z-index: 4;
      background-color: ${theme.palette.background.paper};
      width: 68px;
      min-width: 68px;

      ${
        isLeadingStickyRight === true
          ? css`
            [data-scrollable='true'] & {
              box-shadow: -2px 0px 4px 0px ${alpha(theme.palette.common.black, 0.08)};
            }
          `
          : ''
      }

      tr:hover & {
        background-color: ${theme.palette.background.boxDark};
      }

      tr.Mui-selected & {
        background-color: ${theme.palette.action.selected};
      }
    `}
`;

export interface IconCellProps {
  className?: string;
  stopClickPropagation?: boolean;
  children?: ReactNode;
  sticky?: StickyPosition;
  stickyRightOffset?: number;
  isLeadingStickyRight?: boolean;
}

export function IconCell(props: IconCellProps): JSX.Element {
  const { stopClickPropagation, children, className, sticky, stickyRightOffset, isLeadingStickyRight } = props;
  const cellClassName = `${ICON_CELL_CLASS} ${className ? className : ''}`;

  return (
    <StyledTableCell
      className={cellClassName}
      onClick={stopClickPropagation ? e => e.stopPropagation() : undefined}
      sticky={sticky}
      stickyRightOffset={stickyRightOffset}
      isLeadingStickyRight={isLeadingStickyRight}
    >
      {children}
    </StyledTableCell>
  );
}
